<template>
  <div class="layout_page">
    <el-container class="layout_container">
      <el-aside :width="isCollapse ? '65px' : '200px'">
        <LayoutAside
          :is-collapse="isCollapse"
          @toggle-collapse="toggleCollapse"
        />
      </el-aside>
      <el-container>
        <el-header>
           <LayoutHeader :isCollapse='isCollapse' @toggleCollapse='toggleCollapse'/>
           <!--
          <div>
            <img
              @click="toggleCollapse"
              v-if="isCollapse"
              src="@/assets/img/expand.png"
              alt=""
            />
            <img
              @click="toggleCollapse"
              v-else
              src="@/assets/img/fold.png"
              alt=""
            />
          </div> -->
          <!-- <div>
            <LayoutHeader :isCollapse='isCollapse' @toggleCollapse='toggleCollapse'/>
          </div> -->
        </el-header>
        <el-main>
          <router-view />
        </el-main>
        <el-footer>
          <LayoutFooter />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted } from "vue";
import LayoutAside from "@/components/LayoutAside.vue";
import LayoutHeader from "@/components/LayoutHeader.vue";
import LayoutFooter from "@/components/LayoutFooter.vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
let router = useRouter(); //路由
const route = useRoute();
const isCollapse = ref(false);
const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value;
};
</script>
<style lang="scss" scoped>
.layout_page {
  width: 100%;
  height: 100%;
  .layout_container {
    width: 100%;
    height: 100%;
    background-color: #f5f7f9;
  }
  ::v-deep .el-header,
  ::v-deep .el-aside,
  ::v-deep .el-main,
  ::v-deep .el-footer {
    padding: 0;
  }
  ::v-deep .el-header {
    height: 80px;
    display: flex;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 0px 10px #b6b7b8;
    
    // > div:nth-child(1) {
    //   width: 5%;
    //   height: 100%;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   cursor: pointer;
    //   img {
    //     width: 22px;
    //   }
    // }
    // > div:nth-child(2) {
    //   width: 95%;
    //   height: 100%;
    // }
  }
  ::v-deep .el-aside {
    max-width: 200px;
  }
  ::v-deep .el-footer {
    height: 30px;
  }
}
</style>
